import React from "react"

function DeskReward() {
    return (
        <div>
            <h3>The drawer is empty except for a small photo with a hand scrawled note. Why bother locking this away?!</h3>
            <div className="imageTextWrapper deskRewardWrapper">
                <img className="deskRewardImage" src={"images/desk-reward.jpg"} alt="a small piece of a painting" />
                <h1 className="bottomMiddleImageText deskRewardText">PRESS THERE</h1>
            </div>
        </div>
    )
}

export default DeskReward